import { gql } from "@apollo/client";

export const QUERY_LOAD_LIST = gql`
  query AllLoads($orderBy: [String], $first: Int, $last: Int, $before: String, $after: String) {
    allLoads(orderBy: $orderBy, first: $first, last: $last, before: $before, after: $after) {
      totalCount
      data {
        timePosted
        modfied
        id
        originAddress
        destinationAddress
        originCity
        destinationCity
        originState
        destinationState
        originCountry
        destinationCountry
        originIso2
        originIso3
        destinationIso2
        destinationIso3
        originZip
        originAreacode
        destinationZip
        destinationAreacode
        trailerType
        length
        weight
        targetRate
        timeStart
        timeEnd
        timeDelivery
        matchDate
        details
        recentBid
        linehaulRate
        linehaulDistance
        linehaulDuration
        linehaulRoute
        costPerMile
        linehaulCpm
        cargoValue
        userLoadNumber
        isDeleted
        isRateIndex
        originLocations
        destinationLocations
        attachments
        userType
        postTo
        groups
        groupsPostTo
        status
        modified
        created
        loadId
        originCoords {
          latitude
          longitude
        }
        destinationCoords {
          latitude
          longitude
        }
        user {
          id
          email
          userType
          contactName
          contactEmail
          address
          city
          state
          country
          contactPhone
          mc
          dot
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const QUERY_LOAD_SEARCH = gql`
  query LoadsSearch(
    $trailerType: [String]
    $originRadius: Int
    $originState: String
    $originCity: String
    $destinationRadius: String
    $destinationCity: String
    $destinationState: String
    $weight: Int
    $length_Gte: Int
    $length_Lte: Int
    $timeStart: DateTime
    $timeEnd: DateTime
    $timePosted: DateTime
    $orderBy: [String]
    $first: Int
    $last: Int
    $before: String
    $after: String
  ) {
    loadsSearch(
      trailerType: $trailerType
      originRadius: $originRadius
      originState: $originState
      originCity: $originCity
      destinationRadius: $destinationRadius
      destinationCity: $destinationCity
      destinationState: $destinationState
      weight: $weight
      length_Gte: $length_Gte
      length_Lte: $length_Lte
      timeStart: $timeStart
      timeEnd: $timeEnd
      timePosted: $timePosted
      orderBy: $orderBy
      first: $first
      last: $last
      before: $before
      after: $after
    ) {
      totalCount
      data {
        timePosted
        modfied
        id
        originAddress
        destinationAddress
        originCity
        destinationCity
        originState
        destinationState
        originCountry
        destinationCountry
        originIso2
        originIso3
        destinationIso2
        destinationIso3
        originZip
        originAreacode
        destinationZip
        destinationAreacode
        trailerType
        length
        weight
        targetRate
        timeStart
        timeEnd
        timeDelivery
        matchDate
        details
        recentBid
        linehaulRate
        linehaulDistance
        linehaulDuration
        linehaulRoute
        costPerMile
        linehaulCpm
        cargoValue
        userLoadNumber
        isDeleted
        isRateIndex
        originLocations
        destinationLocations
        attachments
        userType
        postTo
        groups
        groupsPostTo
        status
        modified
        created
        loadId
        isBiddingClosed
        recentBid
        originCoords {
          latitude
          longitude
        }
        destinationCoords {
          latitude
          longitude
        }
        user {
          id
          email
          userType
          contactName
          contactEmail
          address
          city
          state
          country
          contactPhone
          mc
          dot
          hasVerifiedEmail
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
